// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2394a3b8%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Main Layout Wrapper --- */
.ospeed-root {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  color: #f3f4f6;
}

/* --- Card Design --- */
.ospeed-card {
  width: 100%;
  max-width: 420px;
  background: rgba(20, 27, 45, 0.85);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  padding: 24px 20px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4),
              0 0 30px rgba(138, 43, 226, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

/* --- Header Section --- */
.ospeed-top {
  text-align: center;
  margin-bottom: 12px;
}

.ospeed-top .brand {
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.5px;
  background: linear-gradient(135deg, #ffffff 0%, #a5b4fc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.ospeed-top .provider {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 500;
  margin-top: 4px;
}

/* --- Dial Gauge --- */
.ospeed-dial-wrap {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 10px 0 18px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ospeed-dial {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.ospeed-ring-bg {
  fill: none;
  stroke: rgba(255, 255, 255, 0.06);
  stroke-width: 12;
}

.ospeed-arc {
  fill: none;
  stroke-width: 12;
  stroke-linecap: round;
  transition: stroke-dasharray 0.25s ease;
  filter: drop-shadow(0px 0px 8px rgba(255, 102, 179, 0.6));
}

.ospeed-center {
  position: absolute;
  text-align: center;
}

.ospeed-number {
  font-size: 38px;
  font-weight: 800;
  color: #ffffff;
  line-height: 1;
  letter-spacing: -1px;
}

.ospeed-number span {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  margin-top: 6px;
  letter-spacing: 1px;
}

/* --- Metrics Grid --- */
.ospeed-metrics {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 16px;
}

.metric-box {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 14px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.metric-label {
  font-size: 11px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.metric-val {
  font-size: 14px;
  font-weight: 700;
  color: #e2e8f0;
}

/* --- Form Controls --- */
.ospeed-controls {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ospeed-controls select {
  width: 100%;
  background: rgba(15, 23, 42, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #e2e8f0;
  padding: 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
  outline: none;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
}

.ospeed-controls button {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #ff66b3 0%, #8a2be2 100%);
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(138, 43, 226, 0.35);
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.ospeed-controls button:active:not(:disabled) {
  transform: scale(0.98);
}

.ospeed-controls button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* --- Status Text --- */
.status {
  margin-top: 14px;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

/* --- Mobile Device Responsive Adjustments --- */
@media (max-width: 480px) {
  .ospeed-root {
    padding: 8px;
  }
  
  .ospeed-card {
    padding: 20px 16px;
    border-radius: 20px;
  }

  .ospeed-dial-wrap {
    width: 220px;
    height: 220px;
    margin: 6px 0 12px 0;
  }

  .ospeed-number {
    font-size: 32px;
  }

  .ospeed-controls button {
    padding: 12px;
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DiagnosticTools/SpeedTest.css"],"names":[],"mappings":"AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,0DAA0D;EAC1D,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB;+CAC6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,uCAAuC;EACvC,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,2CAA2C;EAC3C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,yDAAwR;EACxR,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+CAA+C;EAC/C,oDAAoD;AACtD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,iDAAiD;AACjD;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');\n\n/* --- Main Layout Wrapper --- */\n.ospeed-root {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n  color: #f3f4f6;\n}\n\n/* --- Card Design --- */\n.ospeed-card {\n  width: 100%;\n  max-width: 420px;\n  background: rgba(20, 27, 45, 0.85);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 24px;\n  padding: 24px 20px;\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4),\n              0 0 30px rgba(138, 43, 226, 0.12);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n/* --- Header Section --- */\n.ospeed-top {\n  text-align: center;\n  margin-bottom: 12px;\n}\n\n.ospeed-top .brand {\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  background: linear-gradient(135deg, #ffffff 0%, #a5b4fc 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.ospeed-top .provider {\n  font-size: 13px;\n  color: #94a3b8;\n  font-weight: 500;\n  margin-top: 4px;\n}\n\n/* --- Dial Gauge --- */\n.ospeed-dial-wrap {\n  position: relative;\n  width: 200px;\n  height: 200px;\n  margin: 10px 0 18px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ospeed-dial {\n  width: 100%;\n  height: 100%;\n  transform: rotate(-90deg);\n}\n\n.ospeed-ring-bg {\n  fill: none;\n  stroke: rgba(255, 255, 255, 0.06);\n  stroke-width: 12;\n}\n\n.ospeed-arc {\n  fill: none;\n  stroke-width: 12;\n  stroke-linecap: round;\n  transition: stroke-dasharray 0.25s ease;\n  filter: drop-shadow(0px 0px 8px rgba(255, 102, 179, 0.6));\n}\n\n.ospeed-center {\n  position: absolute;\n  text-align: center;\n}\n\n.ospeed-number {\n  font-size: 38px;\n  font-weight: 800;\n  color: #ffffff;\n  line-height: 1;\n  letter-spacing: -1px;\n}\n\n.ospeed-number span {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #94a3b8;\n  margin-top: 6px;\n  letter-spacing: 1px;\n}\n\n/* --- Metrics Grid --- */\n.ospeed-metrics {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.metric-box {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 14px;\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.metric-label {\n  font-size: 11px;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 2px;\n}\n\n.metric-val {\n  font-size: 14px;\n  font-weight: 700;\n  color: #e2e8f0;\n}\n\n/* --- Form Controls --- */\n.ospeed-controls {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ospeed-controls select {\n  width: 100%;\n  background: rgba(15, 23, 42, 0.9);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #e2e8f0;\n  padding: 12px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 500;\n  outline: none;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px;\n}\n\n.ospeed-controls button {\n  width: 100%;\n  padding: 14px;\n  border: none;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #ff66b3 0%, #8a2be2 100%);\n  color: #ffffff;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 6px 20px rgba(138, 43, 226, 0.35);\n  transition: transform 0.15s ease, opacity 0.15s ease;\n}\n\n.ospeed-controls button:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.ospeed-controls button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* --- Status Text --- */\n.status {\n  margin-top: 14px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n/* --- Mobile Device Responsive Adjustments --- */\n@media (max-width: 480px) {\n  .ospeed-root {\n    padding: 8px;\n  }\n  \n  .ospeed-card {\n    padding: 20px 16px;\n    border-radius: 20px;\n  }\n\n  .ospeed-dial-wrap {\n    width: 220px;\n    height: 220px;\n    margin: 6px 0 12px 0;\n  }\n\n  .ospeed-number {\n    font-size: 32px;\n  }\n\n  .ospeed-controls button {\n    padding: 12px;\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
